module.exports = __webpack_public_path__ + "img/main_12.cc5f45c4.jpg";